import FileInfo from '@/types/fileInfo';

export function openDownloadLink(file: FileInfo) {
  const link = document.createElement('a');
  link.href = file.file_storage_path;
  link.download = file.file_client_name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
